import angular from 'angular';

import ResponseInterceptor from './services/helpers/response-interceptor/response-interceptor.service';

export const ConfigModule = angular.module('topbroker.config', ['satellizer', 'pascalprecht.translate', 'permission'])
  .service({ ResponseInterceptor })
  .constant('apiHost', '/api/private/v1')
  .constant('apiHost', '/testas/')
  .config(($authProvider, $translateProvider, $compileProvider, $sceDelegateProvider,
    $locationProvider, gravatarServiceProvider,
    $httpProvider, $urlRouterProvider, uiSelectConfig, StripeElementsProvider) => {
    'ngInject';
    // only on produciton
    $compileProvider.debugInfoEnabled(false);
    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);
    //  for debug angular.reloadWithDebugInfo();
    uiSelectConfig.theme = 'selectize';
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      'http://localhost:4200/aGcTAPQh4BkhXmBLGKMa5AW3/',
      'https://www.youtube.com/**',
      'https://www.matterport.com/**',
      'https://matterport.com/**',
      'https://my.matterport.com/**',
      'https://player.vimeo.com/**',
      'https://app.cloudpano.com/**',
      'https://www.giraffevisual.com/**',
      'https://giraffevisual.com/**',

    ]);

    if (window.location.hostname === 'crm.propmage.com') {
      window.apiDomain = 'https://api.propmage.com';
      window.apiHost = window.apiDomain + '/api/private/v1';
    } else {
      window.apiDomain = '';
      window.apiHost = '/api/private/v1';
    }

    window.GOOGLE_CLIENT_ID = '25745912818-tckvkpckhtkirclrjn3tdblaj55f1egi.apps.googleusercontent.com';
    window.GOOGLE_API_KEY = 'AIzaSyBmpDdhX9jn4dopQ6OqzJ4X0fMSdw2Gwcc';
    window.PROPOSAL_HOST = 'https://listing.propmage.com/listing/en/';
    window.GEOPIFY_API_KEY = '389d9fce3f084b0cb5c454bdf761313a';

    $authProvider.loginUrl = window.apiDomain + '/oauth/token';

    $translateProvider.useUrlLoader('/i18n/en.json');
    $translateProvider.preferredLanguage('en');
    $translateProvider.useLoaderCache(true);
    $translateProvider.useSanitizeValueStrategy(null);

    $locationProvider.html5Mode(true);
    // Helper function for determining mobile
    window.isMobile = function () {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };

    gravatarServiceProvider.defaults = {
      size: 29,
      'default': 'mm' // Mystery man as default for missing avatars
    };

    $urlRouterProvider.when('/prisijungti', '/login');
    $urlRouterProvider.otherwise('error/notfound');
    $httpProvider.interceptors.push('ResponseInterceptor');
    $urlRouterProvider.deferIntercept();

    StripeElementsProvider.setAPIKey('pk_test_51Ik401LEPRX5O8IFi48YaSLsthg1bzmZe4eARfYQ5yhZmvICycmhR34hFqcgNLSkfyxbOcaD2NmZH5Cp1halkMXT00lyr1ygqN');

  }).run(($urlRouter, $transitions, $state, Permission, PermRoleStore, PermPermissionStore, $log, $window, $translate, Account) => {
    'ngInject';

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js').then((registration) => {
        window.serviceWorkerRegistration = registration;
      });
    }
    if (process.env.ENV === 'development') {
      // varianble is passed from webpack
      $window.apProposal = 'http://localhost:4200/listing/en/';
    } else if (process.env.ENV === 'production') {
      // varianble is passed from webpack
      $window.apProposal = window.PROPOSAL_HOST;
    }

    async function setPermissions () {
      try {
        await PermRoleStore.clearStore();
        await PermPermissionStore.clearStore();
        await Permission.setPermissions();
        $urlRouter.listen();
        $urlRouter.sync();
      } catch (e) {
        $log.error(e);
      } finally {
        $urlRouter.sync();
      }
    }

    async function setAccountVisualColor() {
      try {
        const root = document.documentElement;
        const resp = await Account.accountVisualIdentity();
        if (resp) {
          root.style.setProperty('--primary-color', resp.primary_color);
        }
      } catch (error) {
        $log.error(error);
      }
    }

    setPermissions();
    setAccountVisualColor();

    $transitions.onStart({}, async (transition) => {
      $state.previous = { ...transition.from(), params: transition.params('from') };
    });

    $transitions.onSuccess({}, (transition) => {
      let title = transition.to().pageTitle || transition.to().name;

      if (title instanceof Function) title = title.call(transition.to(), transition.params(), $translate);

      $translate(title)
        .then(translation => $window.document.title = translation)
        .catch(() => $window.document.title = 'CRM Propmage');

      $window.scrollTo(0, 0);
    });
  }).name;
